// utils/roleLabels.ts
export const roleLabelMap: Record<string, string> = {
  ADMIN: "Admin",
  PROCTOR: "Proctor",
  FRONT_DESK: "Front Desk",
  EXAMINER_RWO: "Examiner",
  EXAMINER_ITWO: "Examiner",
  EXAMINER_HRWOA: "Examiner",
  EXAMINER_HRWOB: "Examiner",
  EXAMINER_HRWOC: "Examiner",
  EXAMINER_HRWOD: "Examiner",
  EXAMINER_DWO: "Examiner",
  EXAMINER_AWO: "Examiner",
  HRWO: "HR",
};
